export function showWarning(value) {
  return value !== 'production' && value !== 'development'
}
